import {auth, types, endpoints} from 'main/tools';
import { makeAutoObservable } from 'mobx';
import {Employee} from 'main/stores/employees';
import {DomainStore} from 'shared/store';
import {redirect} from 'shared/tools';

class OnboardEmployeeInfoState {
  store = new DomainStore();

  employee;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.EMPLOYEE_DETAILS.with(auth.employee.id)
    ]);

    this.employee = new Employee(
      this.store._getSingle(types.EMPLOYEE_DETAILS, {id: auth.employee.id})
    );

  }

  async nextStep() {
    const {model, errors} = await this.store.patch(
      endpoints.EMPLOYEE_ONBOARD.EMPLOYEE_INFO.with(this.employee.id),
      types.EMPLOYEE_DETAILS,
      this.employee
    );
    this.errors = errors;

    if (model) {
      return redirect('/onboard');
    }
  }

  get customGenderVisible() {
    return this.employee.gender === 'other';
  }
}

export default OnboardEmployeeInfoState;
